import React, { useRef } from "react";
import { checkChildrenAndSetFocus } from "../common/interactiveCommon";
const KS2Name = (props) => {
  const {  count, keyName, name, setName, disableAfterCount, smallTitleLabel } = props;
  const nameDivRef = useRef(null);
  const onTextChange = e => {
    checkChildrenAndSetFocus(nameDivRef.current.children, e.target.name.replace(keyName, ""));
    setName({ name: e.target.name, value: e.target.value });
  }
  return (
    <div className="col-sm-12">
    <div className="col-sm-12 col-md-12 col-lg-12 mb-3 section-number-box pl-4 ml-1">
      <div className="mb-3 number" />
      <div className="details">
        <div className="form-group form-inline">
          <div className="" ref={nameDivRef}>
            {[...Array(count).keys()].map(i => (
              <input
                key={`${keyName}${i+1}`}
                maxLength="1"
                type="text"
                id={`${keyName}${(i+1)}`}
                name={`${keyName}${(i+1)}`}
                className="form-control text-center"
                
                value={name[`${i}`]}
                onChange={onTextChange}
                style={{ textTransform: "uppercase" }}
                disabled={i > disableAfterCount ? "disabled" : "" }
              />
            ))}
          </div>
          <small className="small-title-label">{smallTitleLabel}</small>
        </div>
      </div>
    </div>
  </div>
  )
}

export default KS2Name;